<template>
  <div class="text-center">
    <alertaMensaje :snackbar="mostrarSnackbar" :mensajeAlertaData="mensajeAlerta" @update-snackbar="hideSnackbar">
    </alertaMensaje>
    <confirmButton :dialogConfirm="mostrarDialogConfirm" :mensajeDialogData="mensajeDialog"
      @update-dialog="confirmarAcciono" @open-dialog="mostrarDialogConfirm = $event"></confirmButton>
    <v-bottom-sheet width="700" inset v-model="VerlistaSomosHabiles">
      <v-card>
        <v-progress-linear :value="100" class="my-0" height="5"></v-progress-linear>

        <v-list style="max-height: 600px; overflow-y: auto">
          <v-subheader>
            <strong>Lista de Somos Hábiles</strong>
            <sub v-if="showMensaje" style="color:red; margin-left: 5px;">(por favor seleccionar un Somos hábiles
              principal)</sub>
          </v-subheader>

          <div v-if="!showMensaje" class="text-center">
            <strong style="font-size: 14px">... No hay datos para mostrar ...</strong>
          </div>

          <v-radio-group v-else v-model="radioGroup">
            <template v-for="(item, index) in listaExamenesSomosHabiles">
              <v-divider :key="item.codigo"></v-divider>
              <v-list-item :key="index">
                <v-list-item-icon class="ml-0" :class="{ 'mr-3': $vuetify.breakpoint.mdAndUp }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-radio @change="asignarPrincipal(item)" :value="item" v-on="on"></v-radio>
                    </template>
                    <span>Selecciona Somos Hábiles Principal</span>
                  </v-tooltip>
                </v-list-item-icon>
                <v-list-item-avatar>
                  <v-avatar size="50px">
                    <img :src="`https://cdn3d.iconscout.com/3d/premium/thumb/edit-document-8240451-6578676.png`" />
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title># {{ index + 1 }} -
                    {{ item.tipo_muestra }}</v-list-item-title>
                  <v-list-item-subtitle>codigo: {{ item.codigo }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-spacer></v-spacer>

                <v-list-item-icon class="ml-0" :class="{ 'mr-3': $vuetify.breakpoint.mdAndUp }">
                  <v-btn block color="warning" @click="verSomosHabiles(item)">
                    <v-icon left> mdi-eye </v-icon>
                    Ver
                  </v-btn>
                </v-list-item-icon>
                <v-list-item-icon class="ml-0" :class="{ 'mr-3': $vuetify.breakpoint.mdAndUp }">
                  <v-btn block color="error" @click="openDialogDelete(item)">
                    <v-icon left> mdi-delete-forever </v-icon>
                    Eliminar
                  </v-btn>
                </v-list-item-icon>
              </v-list-item>
            </template>
          </v-radio-group>
        </v-list>
      </v-card>
    </v-bottom-sheet>

    <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @close="CloseModal">
    </component>
  </div>
</template>

<script>
//   import NProgress from "nprogress";
// import "nprogress/nprogress.css";
import axios from "@/helpers/axios";
//   import { mapState } from "vuex";
export default {
  name: "listaSomosHabiles",
  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
  },
  components: {
    alertaMensaje: () =>
      import("../../../SimuladorExamenes/components/Co-alertaMensaje.vue"),
    confirmButton: () =>
      import("../../../SimuladorExamenes/components/Co-ComfirMensaje.vue"),
    visorSomosHabiles: () => import("./visorSomosHabiles.vue"),
  },
  data: () => ({
    radioGroup: null,
    //   cantPreguntas: 0,
    //   step: 1,
    //   contadorPreguntas: null,
    showMensaje: true,
    compName: null,
    estadoComponente: true,
    parametroComp: [],
    listaExamenesSomosHabiles: [],
    VerlistaSomosHabiles: true,

    mostrarSnackbar: false, //COMPONENTE ALERTA CONFIRMACION
    mensajeAlerta: "", //COMPONENTE ALERTA CONFIRMACION
    mensajeDialog: "", //COMPONENTE DIALOGO DE CONFIRMACION
    mostrarDialogConfirm: false, //COMPONENTE DIALOGO DE CONFIRMACION

    idmuestra: null,
    itemsDelenting: [],
    //   showAlertaResult: true,
    //   arrayPreguntasYrespuestas: [],
  }),
  methods: {
    openDialogDelete(item) {
      const me = this;
      me.mensajeDialog = "¿ Estás seguro de eliminar este elemento ?";
      me.mostrarDialogConfirm = true;
      me.itemsDelenting = item;
    },

    async confirmarAcciono(e) {
      const me = this;
      // me.validaDialogConfirm = e;
      if (e == true) {
        me.eliminarSomosHabiles(me.itemsDelenting);
      }
    },
    hideSnackbar(e) {
      this.mostrarSnackbar = e;
    },
    // closeLocal() {
    //   this.$emit("close");
    // },
    CloseModal() {
      this.VerlistaSomosHabiles = true;
      this.estadoComponente = false;
    },

    async listarMuestraSomosHabiles() {
      const me = this;
      try {
        const response = await axios.get(
          "/simulador/simuladorExamen/simuladorMuestras/simuladorM/listarMuestrasSomosHabiles/" +
          this.parametros.items.item.id_clase
        );

        if (response.data.length == 0) {
          me.showMensaje = false;
        } else {
          me.listaExamenesSomosHabiles = response.data;
          me.listaExamenesSomosHabiles.forEach((element) => {
            if (element.prioridad == 1) {
              me.radioGroup = element;
            }
          });
          me.showMensaje = true;
        }
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },

    verSomosHabiles(item) {

      const me = this;
      me.VerlistaSomosHabiles = false;
      me.parametroComp = {
        event: "view_somosHabiles",
        items: item,
      };
      me.compName = "visorSomosHabiles";
      me.estadoComponente = true;
    },

    async asignarPrincipal(item) {
      // const me = this;
      try {
        // const response = 
        await axios.delete(
          `/simulador/simuladorExamen/simuladorMuestras/simuladorM/actualizarMainMuestra/${item.idmuestra}/${item.tipo_muestra}/${this.parametros.items.item.id_clase}`
        );
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },

    async eliminarSomosHabiles(item) {

      const me = this;

      try {
        await axios.delete(
          `/simulador/simuladorExamen/simuladorMuestras/simuladorM/eliminarMuestra/${item.idmuestra}/${item.tipo_contenido}`,
        );
        me.listarMuestraSomosHabiles();
        me.itemsDelenting = [];
        me.mostrarDialogConfirm = false;
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },

    init() {
      this.listarMuestraSomosHabiles();
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    estadoComp(e) {
      if (e) {
        this.listarMuestraSomosHabiles();
        this.VerlistaSomosHabiles = true;
      } else {
        this.VerlistaSomosHabiles = false;
      }
    },

    VerlistaSomosHabiles(e) {
      if (!e) {
        this.$emit("closeBottomShet");
      }
    },
  },
};
</script>
